import React, {useEffect} from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import SemiModal from "../semi-modal";
import CloseButton from "../../shared/icon-cross";
import Completed from "./images/completed.svg";
import BankLogo from "./images/bank-logo.svg";
import { parseDateStringWithTime } from "../../../utils/helpers/human-readable-date-parser";
import { sendCustomGaEvents } from "../../../tracking";
import { postInspectionDiyDocUpload } from "../post-inspection-diy/tracking";
import priceFormatter from "../../../utils/helpers/price-formatter";

const PostInspectionDiyTokenDetails = ({
    appointmentId,
    tokenDetails,
    onClose
}) => {
    const { tokenAmount, toAccountNumber, paymentMode, utr, transactionDate = "", toAccountName, paymentGatewayName } = tokenDetails || {};
    const parsedDate = parseDateStringWithTime(transactionDate);

    useEffect(() => {
        sendCustomGaEvents({
            ...postInspectionDiyDocUpload,
            eventAction: "Doc Upload token done pop-up view",
            eventLabel: appointmentId
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <SemiModal>
            <div styleName={"styles.tokenDetailsWrapper"}>
                <div styleName={"styles.tokenDetails"}>
                    <div styleName={"styles.closeWrapepr"}>
                        <CloseButton type={"grey"} onClickHandler={onClose}/>
                    </div>
                    <h5>Token advance Processed<br /> successfully</h5>
                    <h2>₹{priceFormatter(tokenAmount)}</h2>
                    {
                        parsedDate &&
                    <div styleName={"styles.dateTime"}>
                        <img src={Completed} alt="Completed" />
                        {parsedDate}
                    </div>
                    }
                    <div styleName={"styles.bankAccountDetails"}>
                        <div styleName={"styles.banklogo"}>
                            <img src={BankLogo} alt="bank logo" />
                            <p>{toAccountNumber}</p>
                        </div>
                        <ul styleName={"styles.accountInfo"}>
                            <li>
                                <p>From</p>
                                <div>
                                    <span>{paymentGatewayName}</span>
                                </div>
                            </li>
                            <li>
                                <p>To</p>
                                <div>
                                    <span>{toAccountName}</span>
                                </div>
                            </li>
                            <li>
                                <p>Mode of payment</p>
                                <div>
                                    <span>{paymentMode}</span>
                                </div>
                            </li>
                            <li>
                                <p>Transaction id</p>
                                <div>
                                    <span>{utr}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </SemiModal>
    );
};

PostInspectionDiyTokenDetails.propTypes = {
    appointmentId: PropTypes.string,
    tokenDetails: PropTypes.object,
    onClose: PropTypes.func
};

export default PostInspectionDiyTokenDetails;

